import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const PrivacyCard = () => {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");

  const download = async () => {
    const { data } = await api.get("/me/export");
    const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
    Object.assign(document.createElement("a"), { href: url, download: "voyagequeue-my-data.json" }).click();
    URL.revokeObjectURL(url);
  };
  const remove = async () => {
    try {
      await api.post("/me/delete", { confirm });
      toast.success("Your personal details were deleted and your account is closed");
      setUser(false); nav("/");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="mt-10 lux-card p-6 md:p-8" data-testid="privacy-card">
      <p className="eyebrow">Your data</p>
      <p className="text-sm text-slate-400 mt-2 max-w-2xl">Download everything we hold about you, or delete your personal details (name, companions, accessibility notes, children's ages). Deleting cancels autopay and closes your account. Payment records are kept for tax and refunds.</p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button data-testid="privacy-download-btn" onClick={download} className="btn-ghost px-5 py-2.5 text-sm inline-flex items-center gap-2"><Download className="w-4 h-4" />Download my data</button>
        <button data-testid="privacy-delete-open-btn" onClick={() => setOpen(!open)} className="btn-ghost px-5 py-2.5 text-sm inline-flex items-center gap-2 text-rose-300"><Trash2 className="w-4 h-4" />Delete my data</button>
      </div>
      {open && (
        <div className="mt-5 flex flex-wrap items-center gap-3" data-testid="privacy-delete-confirm">
          <input data-testid="privacy-delete-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Type DELETE" className="lux-input !py-2 max-w-[200px]" />
          <button data-testid="privacy-delete-btn" disabled={confirm !== "DELETE"} onClick={remove} className="px-5 py-2.5 text-sm rounded-full bg-rose-500/90 text-white disabled:opacity-40">Permanently delete</button>
        </div>
      )}
    </div>
  );
};
